import { useContext } from "react";
import { AppContext } from "../context/AppContext";

export default function useAppContext(){
    const context = useContext(AppContext);
    if (!context) {
        console.error('useAppContext must be used within an AppContextProvider');
        throw new Error('useAppContext must be used within an AppContextProvider');
    }
    return context
}